import superagent from "superagent";
import config from "../config/app";

const getGoogleFonts = async (sort, category) => {
  if (config.googleFontsUrl) {
    const filters = { sort };
    if (category !== "all") {
      filters.category = category;
    }
    const data = await superagent.get(config.googleFontsUrl).query(filters);
    return data.body.items;
  } else {
    throw Error("No Google Fonts API Key");
  }
};

export default getGoogleFonts;
